/*@flow*/
import { combineReducers } from 'redux';
import search from './reducers/search';
import results from './reducers/results';
import facets from './reducers/facets';
import ui from './reducers/ui';
import translations from './reducers/translations';

export default combineReducers({ search, results, facets, ui, translations });



// WEBPACK FOOTER //
// ./src/reducer.js